import React from 'react';
import CurrentStory from './CurrentStory/CurrentStory';

const buttonStyle = {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  paddingLeft: '10px',
  borderRadius: '5px',
  borderColor: 'lightgray',
  boxShadow: '2px 3px 3px #aaa',
}

const StoryBox = props => {
  const { story, idx, currentStoryIndex, setCurrentStoryIndex } = props;

  return (
    <div
      key={ idx.toString() }
      style={
        {
          padding: '5px',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          backgroundColor: idx === currentStoryIndex ? 'white' : null,
          border: idx === currentStoryIndex ? '1px solid lightgray' : null,
          borderRadius: '5px',
        }
      }
    >
      <button onClick={ () => setCurrentStoryIndex(idx) } style={ buttonStyle } >
        <img
          alt={ `story thumbnail - ${story.title}` }
          height={ 60 }
          src={ story.thumbnailPath }
        />
        <div style={ { padding: '0 10px' } }>
          <h3>{ story.title }</h3>
          <h4>{ story.subtitle }</h4>
        </div>
      </button>
      { currentStoryIndex === idx && <CurrentStory story={ story } /> }
    </div>
  );
};

export default StoryBox;



// WEBPACK FOOTER //
// ./src/components/ForStudents/Stories/StoriesList/StoryBox/StoryBox.js